export enum PreferredPlanner {
  None = 0,
  Bakery = 1,
  HotFood = 3,
}
